import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_plantillahorario_id: new EntityColumn<string>({ name: 'c_plantillahorario_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Plantilla Horario Id' }),
        vc_nombre: new EntityColumn<string>({ name: 'vc_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        plah_brwStandard: {
            name: 'plah_brwStandard', keyMappings: { c_plantillahorario_id: 0 },
        }
    }
)


export class PlantillasHorariosDef extends EntityDefinition {

    columns = columns();
    views = views();


    constructor() {
        super('PlantillasHorarios');
    }
}